import { TrendReportGroupBy, TrendReportType } from "types/graphql-schema";

import { TrendReportFilterItem } from "./filters/types";

export enum TrendReportDataType {
  TALENT_INDICATOR = "talent_indicator",
}

export type TrendReportViewOptions = {
  name: string;
  startDate?: string;
  endDate?: string;
  dataType?: {
    type: TrendReportDataType.TALENT_INDICATOR;
    talentIndicatorId: number;
  };
  reportType: TrendReportType;
  groupBy: TrendReportGroupBy;
  filters: TrendReportFilterItem[];
};
